import { Pagination } from 'antd';
import type { PaginationProps } from 'antd';
import IArrow from '@imgs/icons/arrow-right.svg';

export default function ResetPagination(props: PaginationProps) {
  const itemRender = (current: number, type: any, originalElement: any) => {
    if (type === 'prev') {
      return (
        <span className='page-arrow-left'>
          <IArrow />
        </span>
      );
    }
    if (type === 'next') {
      return (
        <span className='page-arrow-right'>
          <IArrow />
        </span>
      );
    }
    return originalElement;
  };
  return <Pagination {...props} itemRender={itemRender}></Pagination>;
}
